import { object } from "yup";

import { emailValidationSchema } from "@dzambalaorg/yup-rules";

export const managersInviteValidationSchema = object().shape({
  email: emailValidationSchema,
});
